
  import { defineComponent } from 'vue';
  import { Icon } from '@/ui/components/icon/Icon';
  import { ApprovalType } from '@/entities/approvals/constants';

  interface ApprovalTypeProps {
    type: ApprovalType;
  }

  export default defineComponent<ApprovalTypeProps>({
    components: { Icon },
    props: ['type'],
    setup(props) {
      const icon = props.type === ApprovalType.Inspection ? 'copy' : 'bullhorn';

      return {
        icon,
      };
    },
  });
